import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import Navbar from "../../../components/Navbar";
import SideBar from "../../../components/SideBar";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../../constants/index";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import validate from "./validate";
import { toast } from "react-toastify";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FaSpinner } from "react-icons/fa";
import {
    GetServiceCaller,
    PostServiceCaller,
} from "../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
const AddBankForm = () => {
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(true);
    const [submitted, setSubmit] = useState(false);
    const { id } = useParams();
    const [pageTitle, setPageTitle] = useState("");
    const [icon, setIcon] = useState("fa fa-user");
    const handleScroll = () => {
        if (window.scrollY > 50) {
            setPageTitle("Post a Job");
            setIcon("fa fa-user");
        } else {
            setPageTitle("");
            // setIcon('');
        }
    };

    window.addEventListener("scroll", handleScroll);

    let [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        BankName: '',
        DisplayName: '',
        BranchCode: '',
        BranchName: '',
        PhoneNo: '',
        BranchAddress: '',
        IFSCCode: '',
        MICRCode: '',
        SwiftCode: '',
        RTGSNo: '',
        active:1
    });
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(updateNavbarHeading("Add Bank"))
    }, [])
  

    useEffect(() => {
        if (id) {
            fetchData(id);
        }
        setPageLoading(false);
    }, []);

    const fetchData = async (id) => {
        try {
            if (id) {
                try {
                    const response = await GetServiceCaller(
                        `${API_URL}bank/${id}`
                    );
                    if (response?.status === 200) {
                        const bank = response?.data?.bank;
                        if (bank) {
                            setFormData({...formData,
                                'BankName':bank?.Name,
                                'DisplayName':bank?.DisplayName,
                                'BranchCode':bank?.BranchCode,
                                'BranchName':bank?.BranchName,
                                'BranchAddress':bank?.BranchAddress,
                                'PhoneNo':bank?.BranchPhoneNO,
                                'IFSCCode':bank?.IFSCCode,
                                'MICRCode':bank?.MICRCode,
                                'SwiftCode':bank?.SwiftCodeNo,
                                'RTGSNo':bank?.RTGSNo,
                                'active':bank?.IsInactive==1?0:1
                            });
                        } else {
                            console.error("Job not found with ID:", id);
                        }
                    } else {
                        console.error(
                            "Failed to fetch job details. Server responded with status:",
                            response.status
                        );
                    }
                    setPageLoading(false);
                } catch (error) {
                    console.error("Error fetching job details:", error);
                }
            } 
        } catch (error) {
            console.error("Error fetching technology options:", error);
        }
    };
    const handleChange = (e,required=false) => {
        const { name, value, type, checked } = e.target;
        let val = value;
        if (type === "radio") {
            setFormData({ ...formData, [name]: val=="Yes"?1:0 });
        }else{
            setFormData({ ...formData, [name]: val});
        }
        if(required && value!=''){
            setErrors((errors) => ({
                ...errors,
                [name]: {status:false,message:''},
            }));
        }
       
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Validate mandatory fields
        let mandatory_field = ["BankName", "DisplayName"];
        let isFormInvalid = false;
        for (let field of mandatory_field) {
            let error = await validate([field], formData[field], formData);
            if (error.status === true) {
                isFormInvalid = true;
            }
            setErrors((errors) => ({
                ...errors,
                [field]: error,
            }));
        }
        if (!isFormInvalid) {
            setSubmit(true);
            try {
                if (id) {
                   let response = await PostServiceCaller(
                        `${API_URL}bank/${id}`,
                        formData,
                        "put"
                    );
                    toast.success(response?.data?.msg);
                    setSubmit(false);
                    navigate("/banks");
                } else {
                   let response = await PostServiceCaller(
                        `${API_URL}bank`,
                        formData,
                        "post"
                    );
                    toast.success(response?.data?.msg);
                    setSubmit(false);
                    navigate("/banks");
                }
            } catch (error) {
                console.error("Error submitting form data:", error);
            }
        }
    };
    if (pageLoading) {
        return (
            <>
                <p class="position-absolute top-50 start-50 translate-middle text-center">
                    <FaSpinner class="spinner" />
                </p>
            </>
        );
    } else {
        return (
            <>
                    <div className="Container" id="form-input-section">
                        <form
                            onSubmit={handleSubmit}
                            id="formOne"
                            className="rounded bg-white"
                        >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label className="form-label">Bank Name <span className="required">*</span></label>
                                            <input type="text" name="BankName" className="form-control" placeholder="Bank Name" onChange={(e)=>handleChange(e,true)} value={formData.BankName}></input>
                                            {
                                                errors?.BankName?.status && 
                                                <span className="error">{errors?.BankName?.message}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label className="form-label">Display Name <span className="required">*</span></label>
                                            <input type="text" name="DisplayName" className="form-control" placeholder="Display Name"  onChange={(e)=>handleChange(e,true)} value={formData.DisplayName}></input>
                                            {
                                                errors?.DisplayName?.status && 
                                                <span className="error">{errors?.DisplayName?.message}</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">Branch Code</label>
                                            <input type="text" name="BranchCode" className="form-control" placeholder="Branch Code" onChange={handleChange} value={formData.BranchCode}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">Branch Name</label>
                                            <input type="text" name="BranchName" className="form-control" placeholder="Branch Name" onChange={handleChange} value={formData.BranchName}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">Phone No.</label>
                                            <input type="text" name="PhoneNo" className="form-control" placeholder="Phone No" onChange={handleChange} value={formData.PhoneNo}></input>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label className="form-label">Branch Address</label>
                                            <input type="text" name="BranchAddress" className="form-control" placeholder="Branch Address" onChange={handleChange} value={formData.BranchAddress}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">IFSC Code</label>
                                            <input type="text" name="IFSCCode" className="form-control" placeholder="" onChange={handleChange} value={formData.IFSCCode}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">MICR Code</label>
                                            <input type="text" name="MICRCode" className="form-control" placeholder="" onChange={handleChange} value={formData.MICRCode}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">Swift Code</label>
                                            <input type="text" name="SwiftCode" className="form-control" placeholder="" onChange={handleChange} value={formData.SwiftCode}></input>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="form-label">RTGS No.</label>
                                            <input type="text" name="RTGSNo" className="form-control" placeholder="" onChange={handleChange} value={formData.RTGSNo}></input>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="d-flex justify-content-between">
                                        <div className="mt-1">
                                            <div className="d-flex gap-2 justify-content-start">
                                                <label
                                                    htmlFor="IsInActive"
                                                    className="form-label"
                                                >
                                                    Active
                                                </label>
                                                <div className="me-2 mt-0">
                                                    <div className="d-flex">
                                                        <div className="form-check me-2" key={"Yes"}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`active`}
                                                                value={"Yes"}
                                                                checked={
                                                                    formData.active == 1
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) => handleChange(e)}
                                                            />
                                                            <label className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check me-2" key={"No"}>
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`active`}
                                                                value={"No"}
                                                                checked={
                                                                    formData.active == 0
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) => handleChange(e)}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`rating_1_No`}
                                                            >
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <Link to="/banks" className="btn-info me-2">
                                                Cancel
                                            </Link>
                                            <button
                                                disabled={submitted ? true : false}
                                                onClick={handleSubmit}
                                                type=""
                                                className="custom-btn"
                                            >
                                                {submitted ? (
                                                    <FaSpinner class="sm-spinner" />
                                                ) : (
                                                    "Submit"
                                                )}
                                            </button>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            {/* <div class="card-footer text-muted">
                  <div className="d-flex justify-content-end me-2">
                
                  </div>
                </div> */}

                        </form>
                    </div>

            </>
        );
    }
};

export default AddBankForm;
